<template>
  <v-list-tile v-if="url">
    <v-list-tile-action>
      <v-btn icon ripple @click="toggle">
        <v-icon v-if="!isPlaying">play_arrow</v-icon>
        <v-icon v-else>pause</v-icon>
      </v-btn>
    </v-list-tile-action>

    <v-list-tile-action>
      <v-btn icon ripple @click="stop">
        <v-icon>stop</v-icon>
      </v-btn>
    </v-list-tile-action>

    <v-flex xs4>
      <v-list-tile-title>{{part}}</v-list-tile-title>
    </v-flex>

    <v-flex>
      <v-slider :value="progress"></v-slider>
    </v-flex>

    <audio ref="player" @timeupdate="onUpdate">
      <source :src="url">
    </audio>
  </v-list-tile>
</template>
        
<script>
export default {
  props: ["part", "url"],

  data() {
    return {
      progress: 0,
      isPlaying: false
    };
  },

  methods: {
    toggle() {
      if (this.isPlaying) {
        this.$refs.player.pause();
      } else {
        this.$refs.player.play();
      }

      this.isPlaying = !this.isPlaying;
    },

    stop() {
      this.$refs.player.pause();
      this.$refs.player.currentTime = 0;
      this.isPlaying = false;
    },

    onUpdate() {
      if (!this.$refs.player) {
        return;
      }

      this.progress =
        (this.$refs.player.currentTime / this.$refs.player.duration) * 100;
    }
  }
};
</script>